'use strict';
angular.module('editcenterRightsModule', []).factory('editcenterRightsService', [
    '$q',
    'trsHttpService',
    'publicToolService',
    'editingMediatypeToPlat',
    function ($q, trsHttpService, publicToolService, editingMediatypeToPlat) {

        /**
         * [getBtnRights description]根据权限名称归类权限对象
         * @param  {[type]} params [description]各渠道权限请求参数
         * @return {[obj]}        [description]处理过的权限对象集合
         */
        function getBtnRights(params) {
            var defferd = $q.defer();
            var btnRights = {};
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                angular.forEach(data, function (value, key) {
                    btnRights[value.OPERNAME] = value;
                });
                defferd.resolve(btnRights);
            });
            return defferd.promise;
        }
        return {

            /**
             * [initWebsiteListBtn description]网站待编，待审，已签发权限
             * @param  {[str]} methodname [description]网站下各渠道的权限名
             * @param  {[str]} channelid  [description]所属的栏目ID
             * @return {[obj]}            [description]返还的权限位
             */
            initWebsiteListBtn: function (methodname, channelid) {
                var defferd = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    ChannelId: channelid,
                    // StatusType: methodname,
                    Classify: methodname,
                };
                getBtnRights(btnParams).then(function (rights) {
                    defferd.resolve(rights);
                });
                return defferd.promise;
            },

            /**
             * [initWebsiteListBtnWithoutChn description]网站定时签发，废稿，撤稿全选
             * @param  {[str]} methodname [description]网站下各渠道的权限名
             * @param  {[str]} siteid     [description]所属的频道ID
             * @return {[obj]}            [description]返还的权限位
             */
            initWebsiteListBtnWithoutChn: function (methodname, siteid) {
                var defer = $q.defer();
                if (!methodname) {
                    defer.reject();
                } else {
                    var btnParams = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperKeyByBaseChannel',
                        SiteId: siteid,
                        Classify: methodname,
                    };
                    getBtnRights(btnParams).then(function (rights) {
                        defer.resolve(rights);
                    });
                }
                return defer.promise;
            },

            /**
             * [initWebsiteListBtnWithoutForFragment description] 网站网站碎片查询权限
             * @param   {[str]}  methodname      [methodname description]网站下各渠道的权限名
             * @param   {[str]}  siteid          [siteid description]所属的频道ID
             * @param   {[str]}   channelid      [channelid description]栏目ID
             * @return  {[promise]}              [return description]promise
             */
            initWebsiteListBtnWithoutForFragment: function (methodname, siteid, channelid) {
                var defer = $q.defer();
                if (!methodname) {
                    defer.reject();
                } else {
                    var btnParams = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperKeyByBaseChannel',
                        SiteId: siteid,
                        ChannelId: channelid,
                        Classify: methodname,
                    };
                    getBtnRights(btnParams).then(function (rights) {
                        defer.resolve(rights);
                    });
                }

                return defer.promise;
            },

            /**
             * [initAppListBtn description]初始化APP渠道列表按钮权限
             * @param  {[str]} classify  [description]平台分类
             * @param  {[num]} channelid [description]该栏目的ID
             * @return {[type]}           [description]
             */
            initAppListBtn: function (classify, channelid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    Classify: classify,
                    ChannelId: channelid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initAppListBtnWithoutChn description]查询APP渠道下没有栏目的列表权限
             * @param  {[str]} methodname [description]要调用的方法
             * @param  {[num]} siteid     [description]站点ID
             * @return {[type]}            [description]
             */
            initAppListBtnWithoutChn: function (methodname, siteid) {
                var defferd = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    SiteId: siteid,
                    Classify: methodname,
                };
                getBtnRights(btnParams).then(function (rights) {
                    defferd.resolve(rights);
                });
                return defferd.promise;
            },

            /**
             * [initIwoListBtn description]Iwo下权限
             * @param  {[str]} ModalName [description]Iwo下各渠道的权限名
             * @return {[obj]}           [description]Iwo下渠道的权限
             */
            initIwoListBtn: function (ModalName) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'findMyOperRightByModal',
                    ModalName: ModalName,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initIwoBtnMeizi description] 媒资库下的个人素材权限
             *
             * @param   {[type]}  ModalName  [ModalName description]
             * @param   {[type]}  Classify   [Classify description]
             *
             * @return  {[type]}             [return description]
             */
            initIwoBtnMeizi: function (ModalName, Classify) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeysOfNormalModal',
                    ModalName: ModalName,
                    Classify: Classify
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initNewspaperListBtn description]报纸下权限
             * @param  {[str]} methodname    [description]报纸名
             * @param  {[str]} siteId        [description]报纸的站点ID
             * @param  {[str]} channelid     [description]栏目ID
             * @return {[obj]}               [description]返回的报纸权限
             */
            initNewspaperListBtn: function (methodname, siteId, channelid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryPaperOperRightOfModal',
                    ModalName: methodname,
                    SiteId: siteId,
                    Channelid: channelid
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },
            initWeixinListBtn: function (classify, channelid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    Classify: classify,
                    ChannelId: channelid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [getRightsofBigFace description]获得查看痕迹按钮权限
             * @param  {[type]} siteid   [description]站点ID
             * @param  {[type]} Classify [description]分类
             * @return {[type]}          [description]
             */
            getRightsofBigFace: function (siteid, Classify) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    SiteId: siteid,
                    Classify: Classify,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initWeiboListBtn description]  微博下权限
             * @param  {[type]} classify  [description]
             * @param  {[type]} accountid [description] 微博ID
             * @return {[type]}           [description]
             */
            initWeiboListBtn: function (classify, accountid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOfWeiBo',
                    Classify: classify,
                    AccountId: accountid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initTvListBtn description]  电视下权限
             * @param  {[type]} classify  [description]
             * @param  {[type]} channelid [description] 栏目ID
             * @return {[type]}           [description]
             */
            initTvListBtn: function (classify, channelid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyByBaseChannel',
                    Classify: classify,
                    ChannelId: channelid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    let obj = {};
                    for (let i in rights) {
                        obj[i.split('.')[2]] = true;
                    }
                    deferred.resolve(obj);
                });
                return deferred.promise;
            },

            /**
             * [initDouYinListBtn description]  抖音下权限
             * @param  {[type]} classify  [description]
             * @param  {[type]} accountid [description] 微博ID
             * @return {[type]}           [description]
             */
            initDouYinListBtn: function (classify, accountid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOfDouYin',
                    Classify: classify,
                    douYinAccountId: accountid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initDouYinListBtn description]  抖音下权限
             * @param  {[type]} classify  [description]
             * @param  {[type]} accountid [description] 微博ID
             * @return {[type]}           [description]
             */
            initBaiJiaHaoListBtn: function (classify, accountid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOfBaiJiaHao',
                    Classify: classify,
                    accountId: accountid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initDouYinListBtn description]  头条下权限
             * @param  {[type]} classify  [description]
             * @param  {[type]} accountid [description] 头条账号
             * @return {[type]}           [description]
             */
            initToutiaohaoListBtn: function (classify, accountid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOfToutiao',
                    Classify: classify,
                    ChannelId: accountid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initListBtn description] 获取列表按钮权限
             * @param   {[object]}  params   [params description] 请求参数
             * @return  {[promise]}          [return description]
             */
            initListBtn: function(params) {
                var deferred = $q.defer();
                getBtnRights(params).then(function(rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [initQieHaoListBtn description]  企鹅号下权限
             * @param  {[type]} accountid [description] 微博ID
             * @return {[type]}           [description]
             */
            initQieHaoListBtn: function (classify, accountid) {
                var deferred = $q.defer();
                var btnParams = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryOperKeyOfKuaiBao',
                    Classify: classify,
                    AccountId: accountid,
                };
                getBtnRights(btnParams).then(function (rights) {
                    deferred.resolve(rights);
                });
                return deferred.promise;
            },

            /**
             * [judgeCanBeCollected description]统一收藏的稿件的类型
             * @param   {[Array]}      Array  [params description]判断的数组
             * @return  {[type]}  [return description]
             */
            judgeCanBeCollected: function (Array) {
                return Array.some(function (item) {
                    return item.DOCTYPEID != 1 && item.DOCTYPEID != 2 && item.DOCTYPEID != 7 && item.DOCTYPEID != 4;
                });
            },

            /**
             * [initNewMediaBtn description]初始化新媒体渠道按钮权限
             * @param   {[obj]}      params  [params description]请求参数
             * @return  {[promise]}          [return description]promise
             */
            initNewMediaBtn: function (params) {
                var defer = $q.defer();
                var basicParams = {
                    serviceid: 'mlf_metadataright',
                };
                var finalParams = angular.extend(params, basicParams);
                getBtnRights(finalParams).then(function (rights) {
                    defer.resolve(rights);
                });
                return defer.promise;
            },

            /**
             * [selectedArray description]对权限求个交集
             *
             * @param   {[type]}  selectedArray        [selectedArray description]选择的数组
             * @param   {[type]}  hasRequestBtnRights  [hasRequestBtnRights description]已经请求回来的权限
             *
             * @return  {[type]}                       [return description]
             */
            permissionIntersection: function (selectedArray, hasRequestBtnRights) {
                // 从已勾选的权限集合里面进行处理
                var concatArr = [];
                selectedArray.map((obj) => {
                    for (var name in hasRequestBtnRights) {
                        if (obj.CHANNELID === name) {
                            concatArr.push(hasRequestBtnRights[name]);
                        }
                    }
                });
                // 权限求交集
                if (concatArr.length === 1) {
                    return concatArr[0];
                } else {
                    var intersection = angular.copy(concatArr[0]);
                    for (var i = 1; i < concatArr.length; i++) {
                        for (var key in intersection) {
                            if (!concatArr[i][key]) {
                                delete intersection[key];
                            }
                        }
                    }
                    return intersection;
                }
            },

            /**
             * [operManuscriptRight description] 判断是否有操作稿件的权限，目前在个人、已收、部门、稿件档案和共享稿库用到
             * @param   {[object]}  doc  [doc description] 稿件信息
             * @return  {[type]}         [return description]
             */
            operManuscriptRight: function (doc) {
                let defer = $q.defer();
                if (doc && editingMediatypeToPlat[doc.MEDIATYPE] === 'virtual'){ // 如果是虚拟稿则不查询权限
                    defer.resolve({});
                } else {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), {
                        chnlDocId: doc.CHNLDOCID,
                        mediaType: doc.MEDIATYPE,
                        methodname: 'checkDocRight',
                        serviceid: 'zmy_zmyright'
                    }, 'get').then(function (data) {
                        for (var key in data) {
                            data[key] = data[key] === 'true';
                        }
                        publicToolService.getModeconfiguration('IM').then((config) => {
                            if (config && config.sendSwitch === 'on') {
                                data.CANSENDMESSAGETOIM = true;
                            }
                        });
                        defer.resolve(data);
                    });
                }
                return defer.promise;
            }
        };
    },
]);
